import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import classnames from 'classnames';
import { range } from 'lodash';

import EventSelector from '../../../components/EventSelector/Modal';
import EventSelectorButton from '../../../components/EventSelector/Button';
import UpdateButton from '../UpdateButton';
import SectionBtn from './SectionBtn';
import ImageEditor from './ImageEditor';

import {
  setImages,
  save,
  setGraphicsSections,
  loadSelfieMedia,
  selfieSave,
} from './actions';
import { useUpdateEvent } from '../hooks';
import { selfieGraphicsSections } from './selfieSections';
import env from '../../../config/env';

import style from './style.module.scss';

const Graphics = ({
  event,
  sectionsNum,
  setImagesAction,
  saveAction,
  setGraphicsSectionsAction,
  loadSelfieMediaAction,
  selfieSaveAction,
}) => {
  const isEventUdating = useUpdateEvent();
  const isSelfieCam = env.isSelfieCam();

  useEffect(() => {
    if (isSelfieCam) {
      setGraphicsSectionsAction(selfieGraphicsSections);
    }
  }, [setGraphicsSectionsAction, isSelfieCam]);

  useEffect(() => {
    if (!event || isEventUdating) return;
    if (isSelfieCam) {
      const media = event.selfieCam?.media || event.selfiecam?.media || {};
      loadSelfieMediaAction(media);
    } else {
      const { venueType, images: eventImages } = event;
      setImagesAction({ ...eventImages, venueType });
    }
  }, [event, isEventUdating, isSelfieCam]);

  return (
    <div className={style.container}>
      <div className="pageHeader">
        <h4>Graphics</h4>
        <EventSelectorButton showFutureEvents />
        <UpdateButton label="Update Event" updateHandler={isSelfieCam ? selfieSaveAction : saveAction} />
      </div>

      {isEventUdating && (
        <div className="flex-grow-1 d-flex justify-content-center align-items-center">
          <Spinner animation="border" variant="primary" />
        </div>
      )}

      {!isEventUdating && (
        <div className={classnames('d-flex', 'flex-grow-1', style.mainContainer)}>
          <div className={classnames('d-flex', 'flex-column', style.sidebar)}>
            {range(0, sectionsNum).map((index) => <SectionBtn key={index} index={index} />)}
          </div>

          <ImageEditor />
        </div>
      )}

      <EventSelector singleSelection showTemplate showFutureEvents />
    </div>
  );
};

export default connect(
  ({
    events: { selectedEvents, template },
    graphics: { sections },
  }) => ({
    sectionsNum: sections.length,
    event: selectedEvents[0] || template,
  }),
  {
    setImagesAction: setImages,
    saveAction: save,
    setGraphicsSectionsAction: setGraphicsSections,
    loadSelfieMediaAction: loadSelfieMedia,
    selfieSaveAction: selfieSave,
  },
)(Graphics);
